module.exports = __webpack_public_path__ + "static/media/classes-5.e0888717.jpg";